import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AuthKeys } from '@app/api/auth/auth.enum';
import { CarsubsAcessosService } from '@app/api/carsubs-acessos/carsubs-acessos.service';
import { IntegracoesCarsubsService } from '@app/api/integracoes-carsubs/integracoes-carsubs.service';
import { BrandingService } from '@app/shared/services/branding.service';
import { isReservedSegment } from '@app/shared/utils/resolve-organizacao';
import criptografar from '@app/shared/rotinas/criptografar';
import jwt from 'jwt-decode';
import { filter } from 'rxjs';
import { NavigationEnd } from '@angular/router';

@Component({
  standalone: true,
  selector: 'app-root',
  template: ` <router-outlet></router-outlet> `,
  imports: [RouterModule],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  currentStorage = sessionStorage;

  constructor(
    private acessoService: CarsubsAcessosService,
    private integracoesCarsubsService: IntegracoesCarsubsService,
    private brandingService: BrandingService,
    private route: ActivatedRoute,
    private readonly router: Router
  ) { }

  ngOnInit() {
    this.carregarContextoOrganizacaoPorRota(location.pathname.split('/')[1]);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.carregarContextoOrganizacaoPorRota(location.pathname.split('/')[1]);
      });

    this.getCodigoSegmentacao();

  }

  private carregarContextoOrganizacaoPorRota(rotaAtual: string) {
    if (!rotaAtual || isReservedSegment(rotaAtual)) {
      return;
    }

    this.acessoService
      .getCarsubsAcessos(rotaAtual)
      .subscribe((acesso: any) => {
        if (!acesso?.data?.items?.length) {
          return;
        }

        this.currentStorage.setItem(
          AuthKeys.LW_TOKEN,
          criptografar(acesso.data.items[0].TokenLwCarsubs)
        );

        const userData: any = jwt(acesso.data.items[0].TokenLwCarsubs);
        this.currentStorage.setItem(
          AuthKeys.LW_USER,
          criptografar(
            JSON.stringify({
              codigoUsuario: userData.data.userId,
              codigoPessoa: userData.data.codigoPessoa
            })
          )
        );

        sessionStorage.setItem('router', acesso.data.items[0]?.Router);

        if (sessionStorage.getItem('org')) {
          sessionStorage.removeItem('org');
        }

        if (acesso.data.items[0]?.Organizacoes?.CodigoOrganizacao) {
          sessionStorage.setItem(
            'org',
            acesso.data.items[0].Organizacoes.CodigoOrganizacao
          );
        }

        this.getIntegracaoCarsubs();
      });
  }
  setFavicon(url: string) {
    const link: HTMLLinkElement = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = url;
    document.getElementsByTagName('head')[0].appendChild(link);
  }


  getIntegracaoCarsubs() {
    this.integracoesCarsubsService.getIntegracoesCarsubs().subscribe((retorno) => {
      if (retorno) {

        sessionStorage.setItem('imgLoginMobile', retorno.data.items[0]?.UrlImagemLoginMobile ? retorno.data.items[0]?.UrlImagemLoginMobile : '')

        sessionStorage.setItem('imgLogin', retorno.data.items[0]?.UrlImagemLogin ? retorno.data.items[0]?.UrlImagemLogin : '')

        sessionStorage.setItem('logoUrl', retorno.data.items[0]?.UrlLogo ? retorno.data.items[0]?.UrlLogo : '')

        sessionStorage.setItem('logoAlt', retorno.data.items[0]?.AltLogo ? retorno.data.items[0]?.AltLogo : '')

        sessionStorage.setItem('termosCondicoes', retorno.data.items[0]?.TermosCondicoes ? retorno.data.items[0]?.TermosCondicoes : '')

        sessionStorage.setItem('mensagemEscolhaGrupo', retorno.data.items[0]?.MensagemEscolhaGrupo ? retorno.data.items[0]?.MensagemEscolhaGrupo : '')

        this.brandingService.update({
          logoUrl: sessionStorage.getItem('logoUrl') ?? '',
          imgLogin: sessionStorage.getItem('imgLogin') ?? '',
          imgLoginMobile: sessionStorage.getItem('imgLoginMobile') ?? '',
          logoAlt: sessionStorage.getItem('logoAlt') ?? '',
        });

        this.setFavicon(retorno.data.items[0]?.UrlLogo ? retorno.data.items[0]?.UrlLogo : '');
        if (retorno.data.items[0]?.CorPrimaria) {

          document.documentElement.style.setProperty(
            '--info-primary',
            `${retorno.data.items[0]?.CorPrimaria}`
          );
          document.documentElement.style.setProperty(
            '--info-orange',
            `${retorno.data.items[0]?.CorPrimaria}`
          );
          document.documentElement.style.setProperty(
            '--info-gray-02',
            `${retorno.data.items[0]?.CorPrimaria}`
          );
          
          // Set RGB variant for opacity usage
          const rgbPrimary = this.hexToRgb(retorno.data.items[0]?.CorPrimaria);
          if (rgbPrimary) {
            document.documentElement.style.setProperty(
              '--info-primary-rgb',
              `${rgbPrimary.r}, ${rgbPrimary.g}, ${rgbPrimary.b}`
            );
          }
        } else {

          document.documentElement.style.setProperty(
            '--info-primary',
            `#fab500`
          );
          document.documentElement.style.setProperty(
            '--info-orange',
            `#fab500`
          );
          document.documentElement.style.setProperty(
            '--info-primary-rgb',
            `250, 181, 0`
          );
        }

        if (retorno.data.items[0]?.CorSecundaria) {

          document.documentElement.style.setProperty(
            '--info-secondary',
            `${retorno.data.items[0]?.CorSecundaria}`
          );

          // Set RGB variant for opacity usage
          const rgbSecondary = this.hexToRgb(retorno.data.items[0]?.CorSecundaria);
          if (rgbSecondary) {
            document.documentElement.style.setProperty(
              '--info-secondary-rgb',
              `${rgbSecondary.r}, ${rgbSecondary.g}, ${rgbSecondary.b}`
            );
          }

        }
        else {

          document.documentElement.style.setProperty(
            '--info-secondary',
            `#fab500`
          );
          document.documentElement.style.setProperty(
            '--info-orange',
            `#fab500`
          );
          document.documentElement.style.setProperty(
            '--info-secondary-rgb',
            `250, 181, 0`
          );
        }


        if (retorno.data.items[0]?.CorTexto) {
          if (retorno.data.items[0]?.CorTexto == 'B') {
            document.documentElement.style.setProperty(
              '--info-text-white',
              `#FFFFFF`
            );
          } else {
            document.documentElement.style.setProperty(
              '--info-text-white',
              `#000000`
            );
          }
        }
      }
    })
  }

  private hexToRgb(hex: string): { r: number; g: number; b: number } | null {
    // Remove # if present
    hex = hex.replace('#', '');
    
    // Parse hex values
    if (hex.length === 6) {
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      
      if (!isNaN(r) && !isNaN(g) && !isNaN(b)) {
        return { r, g, b };
      }
    }
    
    return null;
  }

  public getCodigoSegmentacao() {
    this.route.queryParams.subscribe((params) => {
      const codigoSegmentacao = params['CodigoSegmentacao'];
      const cpf = params['cpf'];
      const cnpj = params['cnpj'];
      const empresa = params['CodigoEmpresa'];

      if (codigoSegmentacao) {
        sessionStorage.setItem('segmentation', codigoSegmentacao);
      }
      //remove o codigo segmentação caso na tela de município não exista o parâmetro
      else if (location.pathname.includes('municipio') && !codigoSegmentacao) {
        sessionStorage.removeItem('segmentation');
      }

      if (cpf) {
        sessionStorage.setItem('cpf', cpf);
      } else if (location.pathname.includes('municipio') && !cpf) {
        sessionStorage.removeItem('cpf');
      }

      if (cnpj) {
        sessionStorage.setItem('cnpj', cnpj);
      } else if (location.pathname.includes('municipio') && !cnpj) {
        sessionStorage.removeItem('cnpj');
      }

      if (empresa) {
        sessionStorage.setItem('empresa', empresa);
      } else if (location.pathname.includes('municipio') && !empresa) {
        sessionStorage.removeItem('empresa');
      }

      if (codigoSegmentacao && (cpf || cnpj)) {
        const currentRoute = location.pathname;
        this.router.navigate([
          currentRoute.replace('assinatura/municipio', '/auth/sign-in'),
        ]);
      }
    });
  }
}
